/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/BasicInformation/Locations/More/Content"
  
}) {
let constantData = '(and '
let locationsValueData = fromData.useDataFormat({ viewPath,
context: 'locations',
format: fromHelpers.getLocationsLengthMinus1,
})
let constantData1 = ' more)'
let aggregateData = fromAggregate.joinNoSpace(constantData, locationsValueData, constantData1)
let locationsValueData1 = fromData.useDataFormat({ viewPath,
context: 'locations',
format: fromHelpers.getOtherLocations,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 data="'(and '"
 data="locations"
 format="helpers.js getLocationsLengthMinus1"
 data="' more)'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
 marginLeft={dtSpaceMs}
 data="locations"
 format="helpers.js getOtherLocations"
 title={locationsValueData1}
/>
{children}
</React.Fragment>)
}